import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, TextInput, Button, Form, Image, Label } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { TimeoutLink } from 'ui/components/shared';
import { useToasts, useUser, useLayout } from 'hooks';

export const PhoneConfirm = () => {
  const [token, setToken] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { errorToast } = useToasts();
  const { user, redirectTo } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.get(
        `/uext/validations/confirm?type=phone&uid=${user.id}&code=${token}`
      );
      if (response.status === 200) {
        redirectTo(`/sign-up/success?validated=${response.data.emailValidated}`);
        return;
      } else {
        errorToast('Token code is wrong!');
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Phone confirm.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Phone verification</Title>
        <Title type="h3" variant="grey" mb="m">
          Check your token device: (xxx)-xxx-xx{(user.phone || '').slice(-2)}
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Label htmlFor="token" mb="xs">
              Your token code
            </Label>
            <TextInput
              id="token"
              name="token"
              type="token"
              length={4}
              placeholder="4-digit code"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            NEXT
          </Button>
          <TimeoutLink timeout={30} my="m" to="/phone/validate">
            Resend SMS
          </TimeoutLink>
        </Form>
      </Container>
    </AuthLayout>
  );
};
